export const MENU_PRODUCTS = [
  {
    label: "Tortas inteiras",
    id: "tortasinteiras",
    products: [
      {
        id: 1,
        title: "Oreo",
        category: "Torta inteira",
        categoryId: "tortasinteiras",
        description:
          "base de biscoito oreo, mousse de oreo, finalizada com ganache meio amargo, cacau em pó e oreo.",
        price: 150,
        image: require("../assets/images/products/oreo-torta-inteira.JPG"),
      },
      {
        id: 2,
        title: "Banoffee",
        category: "Torta inteira",
        categoryId: "tortasinteiras",
        description:
          "base de biscoito amanteigado, doce de leite mineiro, bananas prata, creme de leite fresco batido e finalizado com canela em pó.",
        price: 120,
        image: require("../assets/images/products/banofe-torta-inteira.JPG"),
      },
      {
        id: 3,
        title: "Uva",
        category: "Torta inteira",
        categoryId: "tortasinteiras",
        description:
          "base de biscoito amanteigado, creme de ninho, uvas sem semente, finalizada com mousse de ninho.",
        price: 150,
        image: require("../assets/images/products/uva-torta-inteira.JPG"),
      },
      {
        id: 4,
        title: "Limão",
        category: "Torta inteira",
        categoryId: "tortasinteiras",
        description:
          "base de biscoito amanteigado, mousse de limão com cream cheese, finalizada com chantininho e raspas de limão.",
        price: 130,
        image: require("../assets/images/products/limao-torta.JPG"),
      },
      {
        id: 5,
        title: "Maracujá",
        category: "Torta inteira",
        categoryId: "tortasinteiras",
        description:
          "base de chocolate, mousse de chocolate meio amargo, mousse levinha de maracujá, finalizada com geléia artesanal de maracujá.",
        price: 140,
        image: require("../assets/images/products/maracuja-torta-inteira.JPG"),
      },
      {
        id: 6,
        title: "Napolitana",
        category: "Torta inteira",
        categoryId: "tortasinteiras",
        description:
          "base de chocolate, mousse de chocolate meio amargo, mousse de morango, mousse de chocolate branco, finalizada com pitanga de creme de ninho e stikadinho.",
        price: 150,
        image: require("../assets/images/products/napolitana-torta.jpeg"),
      },
    ],
  },
  // {
  //   label: "Fatias de torta",
  //   id: "fatiasdetorta",
  //   products: [
  //     {
  //       id: 7,
  //       title: "Oreo",
  //       category: "Fatia",
  //       categoryId: "fatiasdetorta",
  //       description:
  //         "base de biscoito oreo, mousse de oreo, finalizada com ganache meio amargo, cacau em pó e oreo.",
  //       price: 16,
  //       image: require("../assets/images/products/oreo-torta.JPG"),
  //     },
  //     {
  //       id: 8,
  //       title: "Banoffee",
  //       category: "Fatia",
  //       categoryId: "fatiasdetorta",
  //       description:
  //         "base de biscoito amanteigado, doce de leite mineiro, bananas prata, creme de leite fresco batido e finalizado com canela em pó.",
  //       price: 13,
  //       image: require("../assets/images/products/banofe-torta.JPG"),
  //     },
  //     {
  //       id: 9,
  //       title: "Uva",
  //       category: "Fatia",
  //       categoryId: "fatiasdetorta",
  //       description:
  //         "base de biscoito amanteigado, creme de ninho, uvas sem semente, finalizada com mousse de ninho.",
  //       price: 16,
  //       image: require("../assets/images/products/uva-torta.JPG"),
  //     },
  //     {
  //       id: 10,
  //       title: "Limão",
  //       category: "Fatia",
  //       categoryId: "fatiasdetorta",
  //       description:
  //         "base de biscoito amanteigado, mousse de limão com cream cheese, finalizada com chantininho e raspas de limão.",
  //       price: 14,
  //       image: require("../assets/images/products/limao-torta.JPG"),
  //     },
  //     {
  //       id: 11,
  //       title: "Maracujá",
  //       category: "Fatia",
  //       categoryId: "fatiasdetorta",
  //       description:
  //         "base de chocolate, mousse de chocolate meio amargo, mousse levinha de maracujá, finalizada com geléia artesanal de maracujá.",
  //       price: 15,
  //       image: require("../assets/images/products/maracuja-torta.JPG"),
  //     },
  //     {
  //       id: 12,
  //       title: "Napolitana",
  //       category: "Fatia",
  //       categoryId: "fatiasdetorta",
  //       description:
  //         "base de chocolate, mousse de chocolate meio amargo, mousse de morango, mousse de chocolate branco, finalizada com pitanga de creme de ninho e stikadinho.",
  //       price: 16,
  //       image: require("../assets/images/products/napolitana-torta.jpeg"),
  //     },
  //   ],
  // },
  {
    label: "Sobremesas",
    id: "sobremesas",
    products: [
      {
        id: 13,
        title: `Gelado de abacaxi com côco`,
        category: "Sobremesa",
        categoryId: "sobremesas",
        description: `camadas de creme quatro leites, intercaladas com abacaxi caramelizado e finalizado com côco ralado (serve 8 pessoas).`,
        price: 70,
        image: require("../assets/images/products/abacaxi-sobremesa.JPG"),
      },
      {
        id: 14,
        title: `Mini pudim`,
        category: "Sobremesa",
        categoryId: "sobremesas",
        description: "mini pudim de leite condensado e calda de caramelo.",
        price: 8,
        image: require("../assets/images/products/pudim-sobremesa.JPG"),
      },
      {
        id: 15,
        title: `Bombom de uva na travessa`,
        category: "Sobremesa",
        categoryId: "sobremesas",
        description: `creme de leite condensado com chocolate branco, uvas verdes sem semente e ganache de chocolate meio amargo (serve 8 pessoas).`,
        price: 80,
        image: require("../assets/images/products/bombom-de-uva-sobremesa.JPG"),
      },
    ],
  },
];
